export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-6 md:mb-8">
            Votre réparateur de fenêtre à Sélestat
          </h2>
          <div className="space-y-5 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Sélestat, au cœur du vignoble et au pied des Vosges, allie patrimoine médiéval et résidences contemporaines. Des maisons à colombages aux constructions récentes, chaque fenêtre mérite une réparation soignée. Nous intervenons à domicile, pièce comprise.
            </p>
            <p>
              Sélestat, ville des humanistes et porte du vignoble, abrite un patrimoine architectural remarquable. Les maisons à colombages du centre historique côtoient les résidences contemporaines des quartiers périphériques. Cette diversité implique des fenêtres de toutes époques et de tous matériaux. Nous connaissons les spécificités de chaque type et intervenons à domicile.
            </p>
            <p>
              Notre équipe couvre Sélestat et les communes du sud du Bas-Rhin. Le déplacement est gratuit, le diagnostic est gratuit, la pièce de remplacement est comprise et chaque réparation est garantie 10 ans. Nos techniciens arrivent avec un stock de pièces adaptées aux mécanismes les plus courants, qu'il s'agisse de fenêtres anciennes à guillotine ou de modèles modernes à oscillo-battant.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}